export default __webpack_public_path__ + "static/media/Tatjana.48d93da1.png";